var moment = require('moment-timezone');
document.cookie = 'timezone=' + moment.tz.guess() + ';';
